<template>
  <div v-if="level || label" class="monitoring-type-container" :title="label">
    <div class="monitoring bold" :class="chooseColor(level)">{{ level }}</div>
    <div
      class="monitoring label"
      :class="chooseColor(level)"
      :style="config && config.maxElementWidth && !isMobile ? `width:${config.maxElementWidth}px;` : ''"
    >
      {{ label }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    config: {
      type: Object,
      required: false,
      default: () => ({ maxElementWidth: 86 }),
    },

    level: {
      type: Number,
      required: false,
    },

    label: {
      type: String,
      required: false,
    },
  },

  data() {
    return {
      monitoringTypes: {},
    };
  },

  computed: {
    isMobile() {
      return this.$utils.mobilecheck();
    },
  },

  methods: {
    chooseColor(level) {
      const lvl = Number(level);
      if (lvl === 0) {
        return '';
      } else if (lvl <= 3) {
        return 'green';
      } else if (lvl > 3 && lvl <= 6) {
        return 'orange';
      } else {
        return 'red';
      }
    },
  },
};
</script>

<style scoped lang="scss">
@use '@/styles/colors.scss';
@use '@/styles/responsive.scss';
@use '@/styles/fonts.scss';
.monitoring-type-container {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  max-width: 100%;

  .monitoring {
    &.bold {
      font-weight: bold;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    &.label {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    &:nth-child(2n) {
      font-size: 14px;
      flex-shrink: 0;
      color: colors.$lightgrey-color;

      &.red {
        color: colors.$red-color;
      }

      &.green {
        color: colors.$lightgreen-color;
      }

      &.orange {
        color: colors.$orange-color;
      }
    }

    &:not(:nth-child(2n)) {
      font-weight: 500;
      width: 20px;
      height: 20px;
      color: colors.$white-color !important;
      border-radius: 50%;
      font-size: 12px;
      margin: 0 8px 0 0;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
      background: colors.$lightgrey-color;

      &.red {
        background: colors.$red-color;
      }

      &.green {
        background: colors.$lightgreen-color;
      }

      &.orange {
        background: colors.$orange-color;
      }
    }
  }
}
</style>
